export default {
  currentProfileID: 0,
  memberData: {profileCard:{name:{answer:['']}}},
  personalityData: {},
  interestsData: {data:{questions:{}}},
  galleryData: {},
  likes_comments:{}

};
